import type { FC } from 'react';
import React from 'react';
import { Box } from '@mui/material';
import { Iconify } from '@pflegenavi/web-components';
import { useTheme } from '@mui/material/styles';

interface PendingIconOverlayProps {
  size?: 'small' | 'medium';
  position?: 'bottom-right' | 'top-right';
}

export const PendingIconOverlay: FC<PendingIconOverlayProps> = ({
  size = 'small',
  position = 'bottom-right',
}) => {
  const theme = useTheme();

  const iconSize = size === 'small' ? 12 : 16;
  const containerSize = size === 'small' ? 16 : 20;

  const positionStyles = {
    'bottom-right': {
      bottom: -2,
      right: -2,
    },
    'top-right': {
      top: -2,
      right: -2,
    },
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        ...positionStyles[position],
        width: containerSize,
        height: containerSize,
        borderRadius: '50%',
        backgroundColor: theme.palette.info.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: theme.shadows[1],
      }}
    >
      <Iconify
        icon="eva:clock-outline"
        width={iconSize}
        height={iconSize}
        sx={{ color: 'white' }}
      />
    </Box>
  );
};
